@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.swz

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import pl.finn.forms.Zalacznik

@Serializable
data class SwzForm(
    var miejscowoscDokumentu: String? = null,
    var informacje: ArrayList<Informacje> = arrayListOf<Informacje>(),
    var oswiadczenia: ArrayList<Oswiadczenia> = arrayListOf<Oswiadczenia>(),
    var odpowiedz: String? = null,
    var informacjeDodatkowe: ArrayList<InformacjeDodatkowe> = arrayListOf<InformacjeDodatkowe>(),
    var podpis: Podpis = Podpis(),
    var doWiadomosci: DoWiadomosci = DoWiadomosci(),
)
@Serializable
data class SwzFormData(
    val form: SwzForm,
    val zalaczniki: List<Zalacznik>,
    val url: String,
    val token: String?
)
@Serializable
data class Informacje(
    var informacja: String? = null
)
@Serializable
data class InformacjeDodatkowe(
    var informacjaDodatkowa: String? = null
)
@Serializable
data class Oswiadczenia(
    var oswiadczenie: String? = null
)
@Serializable
data class Podpis(

   var zUpowaznienia: String? = null,
   var imieNazwiskoGrupa: ImieNazwiskoGrupa = ImieNazwiskoGrupa(),
   var stanowisko: String? = null,
)
@Serializable
data class Podmiot(
    var instytucja: Instytucja = Instytucja(),
    var osoba: Osoba = Osoba(),
)
@Serializable
data class Instytucja(
    var nazwaInstytucji: String? = null,
    var adres: Adres = Adres(),
)
@Serializable
data class Osoba(
    var imieNazwiskoGrupa: ImieNazwiskoGrupa = ImieNazwiskoGrupa(),
    var adres: Adres = Adres(),
)
@Serializable
data class ImieNazwiskoGrupa(
    var imie: String? = null,
    var imieDrugie: String? = null,
    var nazwiskoCzlonPierwszy: String? = null,
    var nazwiskoCzlonDrugi: String? = null,
    var nazwiskoCzlonTrzeci: String? = null,
)
@Serializable
data class DoWiadomosci(
    var podmiot: Podmiot = Podmiot(),
    var nazwa: String? = null,
)
@Serializable
data class Adres(
    var posiadaAdres: Boolean = false,
    var kodPocztowy: String? = null,
    var poczta: String? = null,
    var miejscowosc: String? = null,
    var ulica: String? = null,
    var budynek: String? = null,
    var lokal: String? = null,
)








